<div
  #activityBlock
  class="activity-block"
  [class]="{
    'activity-block-active': isActive$ | async
  }"
  (click)="selectRequestItem()"
  [dataSelector]="dataSelector + '-container'"
>
  <span class="small-300 activity-block-title" [dataSelector]="dataSelector + '-title'">{{ answerActivity().itemName }}</span>

  <div class="activity-spacer" [dataSelector]="dataSelector + '-spacer'">
    @if(avatar) {
      <app-avatar
        [avatarInput]="avatar"
        [domain]="'contact'"
        [showLabel]="true"
        [dataSelector]="dataSelector + '-avatar'"
      ></app-avatar>
    }

    <span [dataSelector]="dataSelector + '-date-status'">{{ dateStatus }}</span>
  </div>

  <p class="body-300 activity-block-content" [dataSelector]="dataSelector + '-content'">{{ answerActivity().rejectionNotes }}</p>

  <!-- Flagged file alerts -->
  @if(isFileFlaggingEnabled() && flaggedFiles().length > 0) {
    <div class="activity-item__flagged-files-section" [dataSelector]="dataSelector + '-flagged-files'">
      @for(flaggedFile of flaggedFiles(); track flaggedFile.id) {
        <div class="activity-item__flagged-file-alert" [dataSelector]="dataSelector + '-flagged-file-' + flaggedFile.id">
          <span class="activity-item__flagged-file-name">{{ flaggedFile.name }}</span>
          <aiwyn-icon
            name="flag-pennant"
            namespace="phosphor"
            [width]="16"
            [height]="16"
            class="activity-item__flagged-file-icon"
            [dataSelector]="dataSelector + '-flagged-file-icon-' + flaggedFile.id">
          </aiwyn-icon>
        </div>
      }
    </div>
  }
</div>
